<template>
  <div class="news-page">
    <Breadcrumbs :links="breadCrumbsLinks"/>
    <div class="container">
      <div class="container-inner">

       <UsefulMaterialsPage :title="$tHome('News')"/>
      </div>
    </div>
  </div>
</template>

<script>
  const UsefulMaterialsPage = () => import(/* webpackChunkName: "news-page" */ '../views/UsefulMaterialsPage')
  import Breadcrumbs from '../components/Breadcrumbs';
  import globalMetaMixin from '../mixins/globalMetaMixin'

  export default {
    mixins: [globalMetaMixin],
    components: {
      UsefulMaterialsPage,
      Breadcrumbs,
    },
    data() {
      return {

      }
    },
    computed: {
      breadCrumbsLinks() {
        const links = [{
          name: this.$tHome('News')
        }]

        return links
      },
    },
    methods: {

    },
    created() {

      this.setMetaTitleMixin(this.$tMeta('news-list-meta-title'))
      this.setMetaDescriptionMixin(this.$tMeta('news-list-meta-description'))
      this.setOpenGraph({
        title: this.$tMeta('news-list-meta-title'),
        description: this.$tMeta('news-list-meta-description'),
      })
    }
  }
</script>

<style lang="less">


</style>
